export default [
    {
        path: '/supervisor/dashboard',
        name: 'supervisor-dashboard',
        component: () => import('@/views/supervisor/Dashboard.vue'),
        meta: {
            resource: 'supervisor-dashboard',
            action: 'page',
        },
    },
    {
        path: '/supervisor/pharmacy',
        name: 'supervisor-pharmacy',
        component: () => import('@/views/supervisor/pharmacy/List.vue'),
        meta: {
            resource: 'supervisor-pharmacy',
            action: 'page',
        },
    },
    {
        path: '/supervisor/pharmacy-new',
        name: 'supervisor-pharmacy-new',
        component: () => import('@/views/supervisor/pharmacy/New.vue'),
        meta: {
            resource: 'supervisor-pharmacy',
            action: 'page',
        },
    },
    {
        path: '/supervisor/vendor',
        name: 'supervisor-vendor',
        component: () => import('@/views/supervisor/vendor/List.vue'),
        meta: {
            resource: 'supervisor-vendor',
            action: 'page',
        },
    },
    {
        path: '/supervisor/vendor-new',
        name: 'supervisor-vendor-new',
        component: () => import('@/views/supervisor/vendor/New.vue'),
        meta: {
            resource: 'supervisor-vendor',
            action: 'page',
        },
    },
    {
        path: '/supervisor/customers/:slug',
        name: 'supervisor-customers',
        component: () => import('@/views/supervisor/company/CustomerByCompany.vue'),
        meta: {
            resource: 'supervisor-customers',
            action: 'page',
        },
    },
    {
        path: '/supervisor/suppliers/:slug',
        name: 'supervisor-suppliers',
        component: () => import('@/views/supervisor/company/SupplierByCompany.vue'),
        meta: {
            resource: 'supervisor-suppliers',
            action: 'page',
        },
    },
    {
        path: '/supervisor/items',
        name: 'supervisor-item-list',
        component: () => import('@/views/supervisor/item/ItemList.vue'),
        meta: {
            resource: 'supervisor-item-list',
            action: 'page',
        },
    },
    {
        path: '/supervisor/item/:code',
        name: 'supervisor-item-sheet',
        component: () => import('@/views/supervisor/item/ItemSheet.vue'),
        meta: {
            resource: 'supervisor-item-sheet',
            action: 'page',
        },
    },
    {
        path: '/supervisor/supp/items/:code',
        name: 'supervisor-supp-items',
        component: () => import('@/views/supervisor/vendor/Items.vue'),
        meta: {
            resource: 'supervisor-item-sheet',
            action: 'page',
        },
    },
    {
        path: '/supervisor/families',
        name: 'supervisor-family',
        component: () => import('@/views/supervisor/item/Family.vue'),
        meta: {
            resource: 'supervisor-family',
            action: 'page',
        },
    },
    {
        path: '/supervisor/sub-families',
        name: 'supervisor-subFamily',
        component: () => import('@/views/supervisor/item/SubFamily.vue'),
        meta: {
            resource: 'supervisor-subFamily',
            action: 'page',
        },
    },
    {
        path: '/supervisor/dci',
        name: 'supervisor-dci',
        component: () => import('@/views/supervisor/item/DCI.vue'),
        meta: {
            resource: 'supervisor-dci',
            action: 'page',
        },
    },
    {
        path: '/supervisor/company-items/:slug',
        name: 'supervisor-company-items',
        component: () => import('@/views/supervisor/item/CompanyItems.vue'),
        meta: {
            resource: 'supervisor-company-items',
            action: 'page',
        },
    },
    {
        path: '/supervisor/claims',
        name: 'supervisor-claims',
        component: () => import('@/views/administrator/Claims.vue'),
        meta: {
            resource: 'supervisor-claims',
            action: 'page',
        },
    },
    {
        path: '/supervisor/customer/:slug',
        name: 'supervisor-customer-dashboard',
        component: () => import('@/views/administrator/CustomerDashboard.vue'),
        meta: {
            action: 'page',
            resource: 'supervisor-pharmacy',
        },
    },
    {
        path: '/supervisor/portal-orders',
        name: 'supervisor-portal-orders',
        component: () => import('@/views/supervisor/order/PortalOrders.vue'),
        meta: {
            resource: 'supervisor-portal-orders',
            action: 'page',
        },
    },
    {
        path: '/supervisor/connection-tracking',
        name: 'supervisor-connection-tracking',
        component: () => import('@/views/supervisor/ConnectionTracking.vue'),
        meta: {
            resource: 'supervisor-connection-tracking',
            action: 'page',
        },
    },
    {
        path: '/supervisor/logs',
        name: 'supervisor-middleware-logs',
        component: () => import('@/views/supervisor/log/Log.vue'),
        meta: {
            resource: 'supervisor-middleware-logs',
            action: 'page',
        },
    },
    {
        path: '/supervisor/notifications',
        name: 'supervisor-notifications',
        component: () => import('@/views/supervisor/notification/List.vue'),
        meta: {
            resource: 'supervisor-notifications',
            action: 'page',
        },
    },
    {
        path: '/supervisor/website-contact',
        name: 'supervisor-website-contact',
        component: () => import('@/views/supervisor/website/Contact.vue'),
        meta: {
            resource: 'supervisor-website-contact',
            action: 'page',
        },
    },
    {
        path: '/supervisor/vitrine-prospects',
        name: 'supervisor-vitrine-prospects',
        component: () => import('@/views/administrator/Contacts.vue'),
        meta: {
            resource: 'supervisor-website-contact',
            action: 'page',
        },
    },
    {
        path: '/supervisor/vitrine-candidatures',
        name: 'supervisor-vitrine-candidatures',
        component: () => import('@/views/administrator/Candidatures.vue'),
        meta: {
            resource: 'supervisor-website-contact',
            action: 'page',
        },
    },
    {
        path: '/supervisor/website-blog-list',
        name: 'supervisor-website-blog-list',
        component: () => import('@/views/supervisor/website/blog/List.vue'),
        meta: {
            resource: 'supervisor-website-blog',
            action: 'page',
        },
    },
    {
        path: '/supervisor/website-blog',
        name: 'supervisor-website-blog',
        component: () => import('@/views/supervisor/website/blog/Blog.vue'),
        meta: {
            resource: 'supervisor-website-blog',
            action: 'page',
        },
    },
    {
        path: '/supervisor/website-blog/:id',
        name: 'supervisor-website-blog-edit',
        component: () => import('@/views/supervisor/website/blog/Blog.vue'),
        meta: {
            resource: 'supervisor-website-blog',
            action: 'page',
        },
    },
]

